var map = {
	"./title-carousel.de-CH.json": 1320,
	"./title-carousel.de-DE.json": 1321,
	"./title-carousel.en-CA.json": 1322,
	"./title-carousel.en-GB.json": 1323,
	"./title-carousel.en-IN.json": 1324,
	"./title-carousel.en-ME.json": 1325,
	"./title-carousel.en-US.json": 1326,
	"./title-carousel.es-EM.json": 1327,
	"./title-carousel.es-ES.json": 1328,
	"./title-carousel.fr-BE.json": 1329,
	"./title-carousel.fr-CA.json": 1330,
	"./title-carousel.fr-CH.json": 1331,
	"./title-carousel.nl-BE.json": 1332,
	"./title-carousel.nl-NL.json": 1333,
	"./title-carousel.pl-PL.json": 1334,
	"./title-carousel.pt-BR.json": 1335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1319;